
import React, { useState } from 'react';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ButtonGroup,
    CustomInput,
    FormGroup
} from 'reactstrap'
import { useMutation } from 'react-query';
import { useTranslation, Trans } from 'react-i18next';
import { toast } from 'components/Shared/Toast';

import { fetcher } from 'api/client';
// import {linkContract} from 'api/actions/contracts';
import { duplicateContract } from 'api/actions/contracts';

function DuplicateContractModal({ isOpen, toggle, values, onAccept, onChecked, contract }) {
    const { t } = useTranslation();

    return (
        <Modal isOpen={isOpen} centered>
            <ModalHeader>
                {t('contracts.duplicate.duplicate_contract')}
            </ModalHeader>
            <ModalBody>
                <p>
                    <Trans
                        i18nKey="contracts.duplicate.title"
                        values={{ contractName: contract.name }}
                        components={{ b: <strong /> }}
                    />.
                </p>
                <p>{t('contracts.duplicate.options')}:</p>
                <FormGroup>
                    <CustomInput type="checkbox" id="keepParticipants" name="keepParticipants" checked={values.keepParticipants} onChange={onChecked} label={t('contracts.duplicate.keepParticipants')}/> 
                    <CustomInput type="checkbox" id="keepVariables" name="keepVariables" checked={values.keepVariables} onChange={onChecked} label={t('contracts.duplicate.keepVariables')}/> 
                    <CustomInput type="checkbox" id="keepAttachments" name="keepAttachments" checked={values.keepAttachments} onChange={onChecked} label={t('contracts.duplicate.keepAttachments')}/> 
                </FormGroup>
            </ModalBody>
            <ModalFooter className="text-center">
                <ButtonGroup className="d-flex flex-grow-1">
                    <Button color="secondary" onClick={toggle}>
                        {t('contracts.reference.cancel')}
                    </Button>
                    <Button color="primary" type="button" onClick={onAccept}>
                        {t('contracts.duplicate.accept')}
                    </Button>
                </ButtonGroup>
            </ModalFooter>
        </Modal>
    )
}

function DuplicateContractModalContainer({ isOpen, toggle, onSave = () => { }, contract }) {
    const [values, setValues] = useState({ keepVariables: true, keepParticipants: true, keepAttachments: true })
    const { t } = useTranslation();

    const { mutate: mutateDuplicate } = useMutation((payload) => fetcher(duplicateContract(payload)), {
        onSuccess: (data) => {
            if (data._id) {
                toast.success(t('contracts.options.success_duplicate'))
                toggle()
                onSave()
            } else if (data.error) {
                toast.error(data.error ? t('errors' + data.error) : t('contracts.duplicate.duplicate_error'))
            }
        }, onError: (error) => {
            toast.error(t(`errors.${error.message}`, 'contracts.duplicate.duplicate_error'))
        }
    })
    const handleSave = async () => {
        mutateDuplicate({
            contractId: contract._id,
            keep_participants: values.keepParticipants,
            keep_variables: values.keepVariables,
            keet_attachments: values.keepAttachments
        })
    }
    const handleCheckedChange = (evt) => {
        const target = evt.target;
        setValues(currentValues => ({ ...currentValues, [target.name]: target.checked }))
    }

    return (
        <DuplicateContractModal
            isOpen={isOpen}
            toggle={toggle}
            contract={contract}
            values={values}
            onAccept={handleSave}
            onChecked={handleCheckedChange}
        />
    )
}

export default DuplicateContractModalContainer;